const Images = {
    ethLogo: require('./ethereum-icon.png').default,
    ethScan: require('./eth-scan.png').default
};
export default Images;
